/**
 * Product override (E51 / REBUILD-413): hide Failed / QC Failed when the latest log is NPT.
 * NPT keeps qc_passed=false for calendar/history; do not treat that as a QC failure here.
 * Intentionally diverges from legacy Instrument Tasks (no isNPT gate).
 */
export const showsFailedNeedsRerunRibbon = (
  latestQcPassed: boolean | null,
  latestIsNpt: boolean | null = null,
): boolean => latestQcPassed === false && latestIsNpt !== true
